export default {"wrapperCataloguePromotions":"yPoHP"};